export default {
    /**
     * 科学计数法转换,将1000这种正常的数字，转换成1,000这种科学计数法
     */
    scientificNotation(number) {
        if (number === null || number === undefined) {
            return number;
        }
        // 按小数点分隔
        let dataArr = number.toString().split(".");
        let dot = dataArr.length === 2? dataArr[1]: "";
        let data = [];
        let am = parseInt(dataArr[0]);
        while (am > 1000) {
            data.push(Math.floor(am / 1000));
            am = am % 1000;
        }
        if (data.length > 0) {
            // 至少有两段数据，剩下的需要补0
            if (am >= 0) {
                // 需要补0
                if (am < 10) {
                    data.push("00" + am);
                } else if (am < 100) {
                    data.push("0" + am);
                } else {
                    data.push(am);
                }
            }
        } else {
            data.push(am);
        }
        return data.join(",") + (dot.length > 0? "." + dot: "");
    },
    /**
     * 金额转换,科学计数法显示金额
     */
    scientificNotationMoney(val) {
        let amount = val || 0;
        let am = this.scientificNotation(Math.abs(amount).toFixed(2));
        return amount >= 0? am: "-" + am;
    }


}